import { render, staticRenderFns } from "./PLUD.vue?vue&type=template&id=1c457cce&scoped=true"
import script from "./PLUD.vue?vue&type=script&lang=js"
export * from "./PLUD.vue?vue&type=script&lang=js"
import style0 from "./PLUD.vue?vue&type=style&index=0&id=1c457cce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c457cce",
  null
  
)

export default component.exports